const TECH_ID_START_OF_CUSTOM_ASSESSMENT = 100000;
export const TECH_ID_START_OF_AI_JOB_INTERVIEWS = 1000000;

export default TECH_ID_START_OF_CUSTOM_ASSESSMENT;
